import { useMemo } from 'react';

export const useAvailabilitySummaryReportRows = (dataList) => {
  return useMemo(() => {
    return Object.entries(dataList || {}).reduce((result, [key, value]) => {
      result.push({
        name: key,
        rows: value.data.map((row) => ({
          ...row,
          id: row.assignment,
        })),
        total: value.total,
      });
      return result;
    }, []);
  }, [dataList]);
};

export default useAvailabilitySummaryReportRows;
